import { ROLES } from '@/shared/auth';
import type { UserResponse } from '@/shared/api';

export type PlatformRoleState =
  | { kind: 'holder'; canRevoke: boolean }
  | { kind: 'eligible' }
  | { kind: 'ineligible'; reason: string };

/**
 * Was ein Plattform-Admin an diesem Konto mit der Plattformrolle tun kann — dieselben Bedingungen,
 * die der Server prüft (`UserManagementService.PlatformAdmin`). Der Grund steht in der Karte, statt
 * dass eine Schaltfläche erst nach Passwort und Code mit einem Fehler antwortet.
 */
export function platformRoleState(user: UserResponse, isSelf: boolean): PlatformRoleState {
  if (user.roles.includes(ROLES.PlatformAdmin)) {
    return { kind: 'holder', canRevoke: !isSelf };
  }
  if (!user.isActive || !user.emailConfirmed) {
    return {
      kind: 'ineligible',
      reason: 'Möglich, sobald die Einladung angenommen und der Zugang aktiv ist.',
    };
  }
  const workspaceRoles = user.roles.filter((role) => role !== ROLES.PlatformAdmin);
  const internal =
    workspaceRoles.length === 1 &&
    (workspaceRoles[0] === ROLES.WorkspaceAdmin || workspaceRoles[0] === ROLES.Staff);
  if (!internal) {
    return {
      kind: 'ineligible',
      reason: 'Nur Workspace-Admins und Mitarbeiter können Plattform-Admin werden.',
    };
  }
  if (!user.twoFactorEnabled) {
    return {
      kind: 'ineligible',
      reason: 'Dafür muss dieses Konto zuerst die Zwei-Faktor-Anmeldung einrichten.',
    };
  }
  return { kind: 'eligible' };
}
